<section class="reale-theme-style2 fs-6">

    <header [configuration]="headerConfiguration"></header>

    <div fxLayout="column">
        <div class="container">
            <div class="container-product-price">
                <app-product-price-form *ngIf="objectSelected.name" [status]="statusPolicy" [isReadOnly]="true"
                    [readOnlyData]="objectSelected">
                </app-product-price-form>
                <mat-divider></mat-divider>
                <app-coverages-drop-downs [coveragesContract]="coveragesContract" [isReadOnly]="true"></app-coverages-drop-downs>
                <app-coverage-price-card [priceContract]="anualPrice" [isReadOnly]="true"></app-coverage-price-card>
            </div>
            <app-vertical-stepper [stepperIsLinear]="stepperIsLinear" [StepperData]="stepperData"></app-vertical-stepper>
        </div>
        <app-footer></app-footer>
    </div>
</section>